import { useState, useEffect } from 'react';
import { Popup } from '@mono/types/src/platmap';
import { toHash } from '@mono/to-hash';
import { diff } from '@mono/diff';
import { Popup as MapboxPopup } from 'mapbox-gl';
import ReactDOM from 'react-dom';
import React from 'react';

interface usePopupsProps {
    popups: Popup[];
    map?: mapboxgl.Map;
}
export const usePopups = ({ map, popups }: usePopupsProps) => {
    const [mountedPopups, setMountedPopups] = useState<Record<string, MapboxPopup>>({});

    useEffect(() => {
        if (!map) return;
        const { add, remove, overlap } = diff(
            Object.keys(mountedPopups),
            popups.map((popup) => popup.id)
        );

        for (const popupToRemove of remove) {
            mountedPopups[popupToRemove].remove();
            setMountedPopups((prev) => {
                const { [popupToRemove]: _, ...rest } = prev;
                return rest;
            });
        }

        // overlap should update the popup content
        const popupsToAdd = popups.filter((p) => add.includes(p.id));

        for (const popupToAdd of popupsToAdd) {
            const element = document.createElement('div');
            ReactDOM.render(<popupToAdd.Content />, element);

            const mapboxPopup = new MapboxPopup({
                maxWidth: 'none',
                closeButton: false,
                closeOnMove: false,
                closeOnClick: false,
                offset: 10,
                anchor: 'bottom',
            })
                .setLngLat([popupToAdd.lon, popupToAdd.lat])
                .setDOMContent(element)
                .addTo(map);

            setMountedPopups((prev) => ({
                ...prev,
                [popupToAdd.id]: mapboxPopup,
            }));
        }

        for (const popupToUpdate of popups.filter((p) => overlap.includes(p.id))) {
            const element = document.createElement('div');
            ReactDOM.render(<popupToUpdate.Content />, element);

            mountedPopups[popupToUpdate.id].setLngLat([popupToUpdate.lon, popupToUpdate.lat]).setDOMContent(element);
        }
    }, [map, toHash(popups)]);

    return popups.map((p) => p.id);
};
